import { useCallback } from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import { expAutoComplete } from "wvus-forms";
import InputControl from "./InputControl";
import { validators } from "../../languages";
// import { validateExpirationDate, validateIsNotExpired, validateNotPast10Years } from "wvus-forms";

export function ExpirationDateField(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;

  const handleExpValueChange = useCallback(
    (e) => {
      const { formMethods } = props;
      const { getFormState, validateSubForm } = formMethods;

      const fieldStates = getFormState();
      const prevValue = fieldStates.fields.expirationDate.value;
      const fieldValue = e.target.value;
      const fieldName = e.target.name;
      const newFieldValue = expAutoComplete(fieldValue, prevValue);

      formMethods.setValueChange(fieldName, newFieldValue, validateSubForm);
    },
    [formMethods]
  );

  return (
    <InputControl
      fieldId="expirationDate"
      fieldName="expirationDate"
      fieldTitlePhraseKey="payment_step.field_labels.expiration"
      fieldPlaceholder="MM / YY"
      handleValueChange={handleExpValueChange}
      fieldType="tel"
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"is-required"}
      formMethods={formMethods}
      attributes={{
        disabled: disabled,
        autoComplete: "cc-exp"
      }}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      // validators={[validateExpirationDate, validateIsNotExpired, validateNotPast10Years]}
      validators={[validators.expirationDate, validators.isNotExpired, validators.notPast10Years]}
    />
  );
}

export default ExpirationDateField;
